import { Injectable } from "@angular/core";
import { BaseService } from "../services/base.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { StationFollowersList } from "src/swagger-gen/web-secured/models";
import { environment } from "src/environments/environment";
import { UidsBody } from "src/swagger-gen/gnvert-secured/models/uids-body";

@Injectable({
  providedIn: "root",
})
export class StationFollowerRepo extends BaseService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
    super();
  }

  searchStationsFollowers(uids: UidsBody): Observable<StationFollowersList> {
    const url = `${this.baseUrl}/stations/followers/search`;
    const options = {
      headers: this.httpHeaders()
    };
  
    return this.http.post<StationFollowersList>(url, uids, options);
  }
  
}
